import { TagCategory } from '@exam-center/graphql';
import { z } from 'zod';

export const TAG_CATEGORY_OPTIONS = [
  { label: 'รายหมวด', value: TagCategory.Part },
  { label: 'รายวิชา', value: TagCategory.Subject },
];

export const ExamEventScoreReportFilterSectionSchema = z.object({
  examCourse: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .nullish()
    .transform((value) => value ?? null)
    .refine((value) => value !== null, {
      message: 'กรุณาเลือกหลักสูตร',
    }),
  tagCategory: z
    .object({
      label: z.string(),
      value: z.nativeEnum(TagCategory),
    })
    .nullish()
    .transform((value) => value ?? null)
    .refine((value) => value !== null, {
      message: 'กรุณาเลือกประเภทคะแนน',
    }),
});

export type ExamEventScoreReportFilterSectionFormInput = z.infer<
  typeof ExamEventScoreReportFilterSectionSchema
>;
